import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'

@InputType()
export class SendToMilkProducerArgs extends ActionArgs {
  @Field(() => ID)
  ticketId: string

  @Field(() => [String])
  recipients: string[]
}
